import React from 'react';
import { useHistory, useParams } from 'react-router';
import Form from '@dashboard/components/Formik/Form';
import { toast } from '@dashboard/context/ToastContext';
import { useAdminTemplateCategory } from '@dashboard/hooks/queries/useAdminQueries';
import { useUpdateTemplateCategory } from '@dashboard/hooks/queries/useAdminMutations';

const TemplateAdd = () => {
  const { categoryId } = useParams();
  const history = useHistory();

  const {
    data: category,
    isLoading,
    isError,
  } = useAdminTemplateCategory(categoryId);

  const updateCategoryMutation = useUpdateTemplateCategory();

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Something went wrong</div>;

  return (
    <div className="max-w-xl mx-auto mt-16">
      <h1 className="text-lg font-bold mb-4">Edit Template Category</h1>
      <Form
        initialValues={{
          title: category.title,
          slug: category.slug,
          order: category.order,
          publicTitle: category.publicTitle,
          publicDescription: category.publicDescription,
        }}
        fields={[
          {
            name: 'title',
            required: true,
            type: 'text',
            label: 'Category title',
          },
          {
            name: 'slug',
            required: true,
            type: 'text',
            label: 'Slug',
          },
          {
            name: 'publicTitle',
            required: false,
            type: 'text',
            label: 'Page title',
          },
          {
            name: 'publicDescription',
            required: false,
            type: 'textarea',
            label: 'Page description',
            minRows: 8,
            autosize: true,
          },
          {
            name: 'order',
            required: false,
            type: 'number',
            label: 'Order',
            placeholder: 'Automatically generated if left empty',
          },
        ]}
        showState={false}
        onSubmit={async values => {
          const response = await updateCategoryMutation.mutateAsync({
            categoryId,
            data: values,
          });

          return {
            data: response,
            error: response,
            onSuccess: () => {
              toast({
                title: 'Category saved',
              });
              history.push('/admin/template-categories');
            },
          };
        }}
      />
    </div>
  );
};

export default TemplateAdd;
